import { sprintf } from "sprintf-js";

export const formatCurrency = (price) => {
  const formatString = window.NTLF_CONFIG.portal.currency.formatString;
  //
  return sprintf(formatString, price).replace(/ /g, "\u00A0");
};

export const advertFormatCurrency = (price) => {
  const formatString = window.NTLF_CONFIG.portal.currency.advertFormatString;
  // Replace space with no break space character?
  return sprintf(formatString, price || 0).replace(/ /g, "\u00A0");
};

export const formatFullDate = (epoch) => {
  const date = new Date(0);
  date.setUTCSeconds(epoch);
  return date.toLocaleDateString();
};

export const epochToYear = (epoch) => {
  const date = new Date(0);
  date.setUTCSeconds(epoch);
  return date.getFullYear();
};

export const wrapIE10Styles = (styles) => {
  return `
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        ${styles}
    }
    `;
};

/**
 * @returns {"desktop" | "mobilev2"}
 */
export const getClientType = () => {
  // We moved /m2 to /m
  if (document.location.pathname.startsWith("/m/")) {
    return "mobilev2";
  } else if (document.location.pathname.startsWith("/m2/")) {
    return "mobilev2";
  }
  return "desktop";
};

export const clientIsDesktop = () => {
  return getClientType() == "desktop";
};

export const getBoxSize = (fillin, imageSize, containerSize) => {
  let width = 0,
    height = 0,
    topp = 0,
    diff = 0,
    left;
  const dratio = containerSize.width / containerSize.height;
  const sratio = imageSize.width / imageSize.height;

  if (fillin == "fit-in") {
    if (dratio < sratio) {
      diff = containerSize.width / imageSize.width;
      width = containerSize.width;
      height = diff * imageSize.height;
    } else {
      diff = containerSize.height / imageSize.height;
      height = containerSize.height;
      width = diff * imageSize.width;
    }

    const left = containerSize.width / 2 - width / 2;
    const topp = containerSize.height / 2 - height / 2;

    return { x: left, y: topp, width: width, height: height };
  } else {
    if (dratio > sratio) {
      diff = containerSize.width / imageSize.width;
      width = containerSize.width;
      height = diff * imageSize.height;
    } else {
      diff = containerSize.height / imageSize.height;
      height = containerSize.height;
      width = diff * imageSize.width;
    }
    left = containerSize.width / 2 - width / 2;
    topp = containerSize.height / 2 - height / 2;

    //    console.log("Box out", { x: left, y: topp, width: width, height: height });
    return { x: left, y: topp, width: width, height: height };
  }
};

export function sortSubjectPictures(pictures) {
  const defaultSort = (a, b) => {
    const aKeywords = a.keywords.filter(
      (k) =>
        ["individual_picture", "mini_group_picture", "group_picture"].indexOf(
          k,
        ) < 0,
    );
    const bKeywords = a.keywords.filter(
      (k) =>
        ["individual_picture", "mini_group_picture", "group_picture"].indexOf(
          k,
        ) < 0,
    );

    if (
      aKeywords.indexOf("favorite") >= 0 &&
      bKeywords.indexOf("favorite") < 0
    ) {
      return -1;
    } else if (
      aKeywords.indexOf("favorite") < 0 &&
      bKeywords.indexOf("favorite") >= 0
    ) {
      return 1;
    }

    if (
      aKeywords.indexOf("yearbook_pose") >= 0 &&
      bKeywords.indexOf("yearbook_pose") < 0
    ) {
      return -1;
    } else if (
      aKeywords.indexOf("yearbook_pose") < 0 &&
      bKeywords.indexOf("yearbook_pose") >= 0
    ) {
      return 1;
    }

    // Show group pictures last:
    else if (a.groupPicture && !b.groupPicture) {
      return 1;
    }
    if (!a.groupPicture && b.groupPicture) {
      return -1;
    }

    if (a.groupFavoritePicture && !b.groupFavoritePicture) {
      return -1;
    }
    if (!a.groupFavoritePicture && b.groupFavoritePicture) {
      return 1;
    }

    if (a.isUserFavorite && !b.isUserFavorite) {
      return -1;
    } else if (!a.isUserFavorite && b.isUserFavorite) {
      return 1;
    }

    if (a.userBoughtRetouch && !b.userBoughtRetouch) {
      return -1;
    } else if (!a.userBoughtRetouch && b.userBoughtRetouch) {
      return 1;
    }

    // Sort by have tags:
    else if (aKeywords.length > 0 && bKeywords.length === 0) {
      return -1;
    } else if (aKeywords.length === 0 && bKeywords.length > 0) {
      return 1;
    }

    return 0;
  };

  const favorites = pictures.filter(
    (img) => img.keywords.indexOf("favorite") >= 0,
  );

  const portraitImages = pictures
    .filter(
      (img) =>
        img.size.height > img.size.width &&
        img.keywords.indexOf("favorite") < 0,
    )
    .sort(defaultSort);

  const landscapeImages = pictures
    .filter(
      (img) =>
        img.size.height <= img.size.width &&
        img.keywords.indexOf("favorite") < 0,
    )
    .sort(defaultSort);

  return favorites.concat(portraitImages, landscapeImages);
}

export const getPortalCountryCode = () => {
  return window.NTLF_CONFIG.portal.locale.country.twoLetterCode;
};

function getAge(dateString) {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const suspendResource = (promise) => {
  let status = "loading";
  let result;
  const suspender = promise.then(
    (data) => {
      status = "success";
      result = data;
    },
    (error) => {
      status = "error";
      result = error;
    },
  );

  return {
    read() {
      if (status === "loading") {
        throw suspender;
      } else if (status === "error") {
        throw result;
      } else if (status === "success") {
        return result;
      }
    },
  };
};

export const validateSwishishPid = (pid) => {
  const number = pid.replace(/[A-z-+\s]+/, "");

  // Hack for support if customer don't have a number
  if (number == "0000") {
    return true;
  }

  if (number.match(/^[0-9]{10}$/)) {
    let n = 2;
    // Kontrollsum
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      const tmp = parseInt(number[i]) * n;
      tmp > 9 ? (sum += 1 + (tmp % 10)) : (sum += tmp);
      n == 2 ? (n = 1) : (n = 2);
    }
    const total = sum + parseInt(number[9]);
    const ret = !(total % 10);

    if (!ret) {
      return false;
    }

    // Add a age parameter:
    let [, year, month, day] = number.match(/^(\d{2})(\d{2})(\d{2})/);

    if (year < 20) {
      year = parseInt("20" + year);
    } else {
      year = parseInt("19" + year);
    }
    const age = getAge(year + "-" + month + "-" + day);
    return {
      age,
    };
  }
  return false;
};

export const getHumanReadableFileSize = (bytes, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

export const scaleFileObject = (file, dimensions) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const iw = img.width;
      const ih = img.height;
      const scale = Math.min(
        dimensions.maxWidth / iw,
        dimensions.maxHeight / ih,
      );
      const iwScaled = iw * scale;
      const ihScaled = ih * scale;
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
      resolve(canvas.toDataURL());
    };
    img.src = URL.createObjectURL(file);
  });
};

export const stripHTMLFromString = (str) => {
  return str.replace(/(<([^>]+)>)/gi, " ").trim();
};

export const calculateCropRect = (positionInfo, imageSize, containerSize) => {
  const cropRect = {};

  const imageScale = imageSize.width / positionInfo.width;

  if (positionInfo.y > 0) {
    cropRect.y = 0;
    cropRect.height = positionInfo.height * imageScale;
  } else {
    cropRect.y = Math.abs(positionInfo.y) * imageScale;
    cropRect.height = containerSize.height * imageScale;
  }

  if (positionInfo.x > 0) {
    cropRect.x = 0;
    cropRect.width = positionInfo.width * imageScale;
  } else {
    cropRect.x = Math.abs(positionInfo.x * imageScale);
    cropRect.width = containerSize.width * imageScale;
  }

  // Fix rounding errors:
  const [roundX, roundWidth] = getRoundedValues(
    parseInt(cropRect.x),
    parseInt(cropRect.width),
    imageSize.width,
  );
  const [roundY, roundHeight] = getRoundedValues(
    parseInt(cropRect.y),
    parseInt(cropRect.height),
    imageSize.height,
  );

  const roundedCropRect = {
    x: roundX,
    y: roundY,
    width: roundWidth,
    height: roundHeight,
  };

  return roundedCropRect;
};

function getRoundedValues(pos, size, sourceSize) {
  while (pos + size > sourceSize) {
    // We can't have crop rect bigger than image size, so reset:
    if (size > sourceSize) {
      pos = 0;
      size = sourceSize;
    }
    // Reduce size first?
    else if (pos + size > sourceSize) {
      size--;
    }
  }
  return [pos, size];
}

export const cropRectToImagePosition = (
  cropRect,
  imageSize,
  containerSize,
  adaption,
) => {
  const position = getBoxSize(adaption, cropRect, containerSize);

  const diff = cropRect.width / position.width;
  const y = -cropRect.y / diff;
  const x = -cropRect.x / diff;
  const width = imageSize.width / diff;
  const height = imageSize.height / diff;

  const newPosition = {
    x,
    y,
    width,
    height,
    container: {
      width: position.width,
      height: position.height,
    },
  };

  return newPosition;
};

const inputTypes = [
  window.HTMLInputElement,
  window.HTMLSelectElement,
  window.HTMLTextAreaElement,
];

export const triggerInputChange = (node, value = "") => {
  // only process the change on elements we know have a value setter in their constructor
  if (inputTypes.indexOf(node.__proto__.constructor) > -1) {
    const setValue = Object.getOwnPropertyDescriptor(
      node.__proto__,
      "value",
    ).set;
    const event = new Event("input", { bubbles: true });

    setValue.call(node, value);
    node.dispatchEvent(event);
  }
};
